module.exports = __webpack_public_path__ + "static/Strands_Become_a_Partner-b274e5740bb65df3571b025b01c05cf9.png";